export default "__VITE_ASSET__b3e53f62__"